import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Sedancabservicemumbai() {



  const cardData = {
    keyword: " Sedan Cab Service Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and comfortable sedan cab services in Mumbai, providing an ideal travel solution for city rides, airport transfers, corporate travel, and outstation journeys. Sedan cars like Swift Dzire and Toyota Etios are highly preferred for their smooth ride quality, spacious interiors, and cost-effective pricing, making them perfect for small families and business travelers. Our professional drivers and well-maintained vehicles ensure a safe, punctual, and stress-free travel experience across Mumbai and nearby destinations. Sedan cab fares in Mumbai typically start from around ₹12 per km for outstation trips and flexible hourly packages for local travel. :contentReference[oaicite:0]{index=0} We offer one-way, round trip, and full-day rental options with transparent pricing and no hidden charges. With easy booking and 24/7 availability, Royal Route Cab is your trusted choice for sedan cab service in Mumbai.",

"topPlaces": [
  {
    "title": "Sedan Cab Service Mumbai",
    "description": "Sedan cab service in Mumbai is a preferred transportation option for business travelers, tourists, and local commuters seeking a comfortable and reliable travel experience. Sedan cars offer a smooth ride, modern amenities, and convenience for city and outstation journeys."
  },
  {
    "title": "Sedan Taxi Service Mumbai",
    "description": "Sedan taxi service in Mumbai provides affordable and convenient transportation for airport transfers, corporate travel, sightseeing tours, and daily commuting. Passengers enjoy comfortable seating and a hassle-free travel experience."
  },
  {
    "title": "Sedan Cab with Driver Mumbai",
    "description": "Sedan cab with driver services in Mumbai allow travelers to enjoy professional chauffeur-driven transportation. It is an ideal choice for business meetings, family outings, and stress-free city travel."
  },
  {
    "title": "Mumbai Airport Sedan Cab Service",
    "description": "Mumbai Airport sedan cab services are widely used for airport pickups and drop-offs. The vehicles offer comfortable seating, air conditioning, and sufficient luggage space for a smooth travel experience."
  },
  {
    "title": "Affordable Sedan Cab Mumbai",
    "description": "Affordable sedan cab services in Mumbai provide budget-friendly transportation without compromising on comfort and reliability. They are suitable for local travel, office commutes, and personal trips."
  },
  {
    "title": "Sedan Cab for Outstation Mumbai",
    "description": "Sedan cabs are a popular choice for outstation travel from Mumbai due to their comfort, fuel efficiency, and smooth driving experience. They are ideal for trips to Pune, Lonavala, Nashik, and other nearby destinations."
  },
  {
    "title": "Corporate Sedan Cab Service Mumbai",
    "description": "Corporate sedan cab services in Mumbai cater to business professionals who require punctual and comfortable transportation for meetings, conferences, and corporate events."
  },
  {
    "title": "Sedan Cab for Local Travel Mumbai",
    "description": "Sedan cabs are commonly booked for local travel within Mumbai, offering passengers a convenient way to navigate the city comfortably while avoiding the hassles of driving and parking."
  },
  {
    "title": "Luxury Sedan Cab Service Mumbai",
    "description": "Luxury sedan cab services in Mumbai provide premium transportation with well-maintained vehicles, professional drivers, and enhanced comfort for special occasions and executive travel."
  },
  {
    "title": "Best Sedan Cab Service Mumbai",
    "description": "The best sedan cab services in Mumbai focus on customer satisfaction, safety, and reliable transportation. They are frequently chosen for airport transfers, business travel, sightseeing, and everyday commuting."
  }
],






services: [
  {
    name: "Sedan Cab Service Mumbai",
    description: "Sedan cab service Mumbai offers comfortable and affordable travel for individuals and small families. Sedans are known for smooth rides, good mileage, and easy city navigation. Ideal for local travel, airport transfers, and outstation trips. Professional drivers ensure safety. It guarantees a pleasant and hassle-free journey."
  },
  {
    name: "Sedan Taxi Service Mumbai",
    description: "Sedan taxi service Mumbai provides reliable transportation with well-maintained cars and experienced chauffeurs. This service is perfect for daily commuting and business travel. Flexible booking options enhance convenience. It ensures a smooth and comfortable ride."
  },
  {
    name: "Sedan Car Rental Mumbai",
    description: "Sedan car rental Mumbai offers flexible travel solutions for personal and corporate use. Customers can rent sedans for hourly, daily, or long-distance travel. Clean vehicles and easy booking ensure convenience. It guarantees a comfortable journey."
  },
  {
    name: "Sedan Cab Booking Mumbai",
    description: "Sedan cab booking Mumbai allows customers to reserve their ride easily with flexible options. Travelers can select pickup location, timing, and travel plan. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Sedan Taxi Booking Online Mumbai",
    description: "Sedan taxi booking online Mumbai provides a quick and convenient way to book cabs. Customers can compare pricing and vehicle options easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Sedan Cab Price Mumbai",
    description: "Sedan cab price Mumbai varies based on distance, trip type, and duration. Transparent pricing ensures no hidden charges. Budget-friendly rates make sedans a popular choice. It helps travelers plan efficiently. It ensures value for money."
  },
  {
    name: "Sedan Taxi Fare Mumbai",
    description: "Sedan taxi fare Mumbai is designed to be affordable for city and outstation travel. Fare depends on route and usage. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Sedan One Way Cab Mumbai",
    description: "Sedan one way cab Mumbai is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for airport and intercity travel. It ensures smooth and economical journeys."
  },
  {
    name: "Sedan Round Trip Cab Mumbai",
    description: "Sedan round trip cab Mumbai is ideal for travelers planning return journeys. This service includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and business travel. It ensures comfort and efficiency."
  },
  {
    name: "Cheap Sedan Cab Mumbai",
    description: "Cheap sedan cab Mumbai offers budget-friendly travel options without compromising comfort. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Sedan Taxi Service Mumbai",
    description: "Best sedan taxi service Mumbai ensures top-quality vehicles and professional drivers for a smooth travel experience. This service focuses on punctuality, comfort, and customer satisfaction. It guarantees a reliable journey."
  },
  {
    name: "Dzire Sedan Cab Mumbai",
    description: "Dzire sedan cab Mumbai is one of the most preferred options for economical and comfortable travel. Known for its mileage and smooth ride, it is ideal for city and outstation trips. Professional drivers ensure safe travel. It guarantees a pleasant experience."
  },
  {
    name: "Etios Sedan Cab Mumbai",
    description: "Etios sedan cab Mumbai provides reliable and spacious travel for individuals and families. This vehicle offers comfort and durability for long journeys. Ideal for local and outstation travel. It ensures a smooth ride."
  },
  {
    name: "Sedan Airport Cab Mumbai",
    description: "Sedan airport cab Mumbai offers convenient pickup and drop services to Mumbai airport. This service ensures timely travel and comfortable rides. Ideal for business travelers and tourists. It guarantees a stress-free airport transfer."
  },
  {
    name: "Sedan Outstation Cab Mumbai",
    description: "Sedan outstation cab Mumbai provides reliable long-distance travel with comfortable seating and good mileage. This service is ideal for family trips and business travel. Vehicles are maintained for highway performance. It ensures a safe and enjoyable journey."
  }
],

tableData: [
  ["Sedan Cab Service Mumbai", "Sedan Taxi Service Mumbai"],
  ["Sedan Car Rental Mumbai", "Sedan Cab Booking Mumbai"],
  ["Sedan Taxi Booking Online Mumbai", "Sedan Cab Price Mumbai"],
  ["Sedan Taxi Fare Mumbai", "Sedan One Way Cab Mumbai"],
  ["Sedan Round Trip Cab Mumbai", "Cheap Sedan Cab Mumbai"],
  ["Best Sedan Taxi Service Mumbai", "Dzire Sedan Cab Mumbai"],
  ["Etios Sedan Cab Mumbai", "Sedan Airport Cab Mumbai"],
  ["Sedan Outstation Cab Mumbai", "Sedan Cab Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Sedan Cab Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly sedan cab service in Mumbai, perfect for daily travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Comfortable & Smooth Ride Experience",
    WhyChoosedescription: "Sedan cars like Swift Dzire and Etios provide a smooth, comfortable ride ideal for city travel and long-distance journeys."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Mumbai routes, ensuring safe and hassle-free travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing with no hidden costs, ensuring complete transparency."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our sedan cab service in Mumbai is available 24/7 for flexible travel anytime."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All sedan vehicles are regularly serviced, sanitized, and maintained for a comfortable travel experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book sedan cabs for local Mumbai travel, airport pickup-drop, or outstation trips with flexible packages."
  },
  {
    WhyChooseheading: "Trusted Sedan Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable sedan cab service in Mumbai with punctual drivers and smooth service."
  }
]

};

const faqData = [
  { question: "Do you provide sedan cab service in Mumbai?", answer: "Yes, Royal Route Cabs offers sedan cab services in Mumbai for local and outstation travel." },
  { question: "Which sedan cars are available?", answer: "We provide Swift Dzire, Etios, and similar sedan cars." },
  { question: "Is sedan cab service available 24 hours?", answer: "Yes, our sedan cab service operates 24/7." },
  { question: "Is sedan suitable for outstation travel?", answer: "Yes, sedan cars are ideal for both city and long-distance travel." },
  { question: "Do you provide airport pickup with sedan?", answer: "Yes, we offer Mumbai airport pickup and drop services with sedan cars." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Can I book sedan for one-way trips?", answer: "Yes, we provide one-way and round-trip booking options." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Joshi",
    feedback: "Sedan cab in Mumbai with Royal Route Cabs was very comfortable and smooth. The car was clean and perfect for both short and long city rides.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback: "Good experience with sedan cab service in Mumbai. The ride was punctual, the vehicle was well-maintained, and the journey felt safe and relaxed.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/sedan-cab-service-mumbai.jpg", // replace if needed
  "description": "Book sedan cab service in Mumbai with Royal Route Cabs for comfortable and affordable travel. Ideal for airport transfers, local rides, and outstation trips. Available with Dzire, Etios, and similar sedan cars with 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/sedan-cab-service-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Sedan Cab Service Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book sedan cab service in Mumbai with Royal Route Cabs. Affordable Dzire & Etios taxis for local, airport, and outstation travel. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="sedan cab service mumbai, sedan taxi service mumbai, sedan car rental mumbai, sedan cab booking mumbai, sedan taxi booking online mumbai, sedan cab price mumbai, sedan taxi fare mumbai, sedan one way cab mumbai, sedan round trip cab mumbai, cheap sedan cab mumbai, best sedan taxi service mumbai, dzire sedan cab mumbai, etios sedan cab mumbai, sedan airport cab mumbai, sedan outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabservicemumbai;